import * as React from 'react';
import { useEffect, useRef } from 'react';
import * as L from 'leaflet';

import { getImageBlob } from '@components/map/_mapActions';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';

const getImageAddress = async ({ url, layers, width, height, bounds }) => {
  const imageUrl =
    url +
    '&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&STYLES&SRS=EPSG%3A4326' +
    `&LAYERS=${layers}` +
    `&WIDTH=${width}&HEIGHT=${height}` +
    `&BBOX=${bounds._southWest.lng}%2C${bounds._southWest.lat}%2C${bounds._northEast.lng}%2C${bounds._northEast.lat}`;

  const imageBlob = await getImageBlob(imageUrl);
  return URL.createObjectURL(imageBlob);
};

const getMapCoordination = code => {
  switch (code) {
    case 'milovice':
    return { lat: 50.226655, lng: 14.885022, zoom: 13 };
    case 'lipa':
      return { lat: 50.6785, lng: 14.5397, zoom: 13 };
    case 'karvina':
      return { lat: 49.85437, lng: 18.541321, zoom: 12 };
    case 'havirov':
      return { lat: 49.7751397, lng: 18.4344665, zoom: 13.5 };
    case 'cesbrod':
      return { lat: 50.073846533092066, lng: 14.862510674865918, zoom: 14 };
    case 'zdarns':
      return { lat: 49.562968, lng: 15.941076, zoom: 13 };
    default:
      return { lat: 49.85437, lng: 18.541321, zoom: 12 };
  }
};

export const LeafletMap = ({ layers }) => {
  const {
    config: { code }
  } = getConfigurationContext();
  const [bounds, setBounds] = React.useState<any>(null);
  const divMap: any = useRef(null);
  const { lat, lng, zoom } = getMapCoordination(code);

  // create map
  const mapRef: any = useRef(null);
  useEffect(() => {
    mapRef.current = L.map('map', {
      center: [lat, lng],
      zoom: zoom,
      layers: [
        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        })
      ]
    });
    setBounds(mapRef.current.getBounds());

    mapRef.current.on('moveend', function() {
      setBounds(mapRef.current.getBounds());
    });
    mapRef.current.on('zoomend', function() {
      setBounds(mapRef.current.getBounds());
    });
  }, []);

  // add layer
  const layerRef: any = React.useRef(null);
  useEffect(() => {
    layerRef.current = L.layerGroup().addTo(mapRef.current);
  }, []);

  // update layers
  useEffect(() => {
    const addLayer = async ({ layers: layersLabel, url }) => {
      const imageUrl = await getImageAddress({
        url,
        layers: layersLabel,
        bounds,
        height: divMap.current.clientHeight,
        width: divMap.current.clientWidth
      });
      L.imageOverlay(imageUrl, bounds).addTo(layerRef.current);
    };

    layerRef.current.clearLayers();
    layers.forEach(addLayer);
  }, [layers, bounds, divMap]);

  return <div id="map" ref={divMap} style={{ height: 'calc(100vh - 260px)' }} />;
};



// WEBPACK FOOTER //
// ./src/components/map/LeafletMap.tsx